import type { ReactNode, SVGProps } from 'react'

/** Een klok: het paneel Geschiedenis (R-97, ontwerp A van het invulscherm). */
export function ClockIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-5)', height: 'var(--nwo-space-sp-5)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
    </svg>
  )
}
